import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { notification } from 'antd'
import { IDeleteSurveyPayload } from '@app-store/slices/survey/deleteSurvey'

interface TaskAction extends Action {
    payload: IDeleteSurveyPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.survey.deleteSurvey

function* deleteSurveySagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/meeting/survey/${payload.surId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Survey deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess()
        } else {
            yield payload.sagaCB?.onError()
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload.sagaCB?.onError()
    }
}

function* deleteSurveySaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteSurveySagaTask)
}

export default deleteSurveySaga
